<template>
  <Transition name="list">
    <div id="divFeesAndTaxesV2">
      <div v-for="(feeOrTax, index) in feesAndTaxes" :key="index" class="col">
        <InputFieldPrice
          id="fee-or-tax-{{ feeOrTax.id }}"
          :disabled="true"
          :currency="currency"
          :inputValue="feeOrTax.value"
          :is-self-service="isSelfOnboarding"
          :label-name="t(feeOrTax.labelTranslationKey)"
          :visible="false"
        />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, ComputedRef, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import InputFieldPrice from "@/apps/merchant3/shared-components/input-fields/InputFieldPrice.vue";
import useCurrency from "@/apps/merchant3/shared-hooks/useCurrency";
import { IFeeOrTaxComponentDTO } from "@/apps/merchant3/models/IStateCart";
const { getCurrency } = useCurrency();

const props = defineProps({
  isSelfOnboarding: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const { t } = useI18n();
const isSelfOnboarding = ref(props.isSelfOnboarding);
const currency = computed(() => {
  return getCurrency(store.state.merchant?.merchant?.country);
});
const feesAndTaxes: ComputedRef<IFeeOrTaxComponentDTO[]> = computed(() => {
  const selectedTerm: number = store.state.carts?.months || 0;
  return store.state.carts?.pricing?.[selectedTerm]?.offersFeesAndTaxesDTOs;
});
</script>
